import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "h-full md:h-96" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Welcome Back!"),
  /*#__PURE__*/_createElementVNode("h2", { class: "font-medium" }, "Tell Us About Yourself"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, " We’re collecting additional information to offer you the best experience while using Snap! Mobile ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-gray-800 mb-1" }, " Your Organization ", -1)
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-gray-800"
}
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "h-full md:h-96" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RolesSelect = _resolveComponent("RolesSelect")!
  const _component_snap_link = _resolveComponent("snap-link")!
  const _component_OrgsSearchList = _resolveComponent("OrgsSearchList")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    ref: "selfIdentifyDialog",
    "is-back": _ctx.isBack,
    "is-modal": false,
    onClose: _ctx.onClose,
    onBack: _ctx.onBack
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          autocomplete: "off",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createVNode(_component_RolesSelect, {
            modelValue: _ctx.roleId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleId) = $event)),
            label: "Your Role",
            validation: _ctx.v$.roleId,
            class: "mb-4"
          }, null, 8, ["modelValue", "validation"]),
          _createElementVNode("div", null, [
            _hoisted_3,
            (!_ctx.org)
              ? (_openBlock(), _createBlock(_component_snap_link, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.set('ORGS_SEARCH'))),
                  size: "sm",
                  icon: "chevron-right-solid",
                  "icon-position": "right"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Search For My Organization ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.org)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.org.name), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.orgAddress(_ctx.org)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.org)
              ? (_openBlock(), _createBlock(_component_snap_link, {
                  key: 2,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.set('ORGS_SEARCH'))),
                  size: "sm",
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Oops, this is not my organization. ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ], 512), [
        [_vShow, _ctx.state.is('NORMAL') || _ctx.state.is('SUBMITTING')]
      ]),
      _withDirectives(_createElementVNode("section", _hoisted_6, [
        _createVNode(_component_OrgsSearchList, { onSelect: _ctx.onOrgSelect }, null, 8, ["onSelect"])
      ], 512), [
        [_vShow, _ctx.state.is('ORGS_SEARCH')]
      ])
    ]),
    _: 1
  }, 8, ["is-back", "onClose", "onBack"]))
}